var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speech-bubble-menu",class:{ darkmode: _vm.darkMode },style:(_vm.position)},[_vm._t("default"),_c('div',{staticClass:"arrow"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }